import {FontAwesomeIcon as Icon} from "@fortawesome/react-fontawesome"
import _ from "lodash"
import {AppMenu} from "mixins/menu"
import React from "react"
import Modal from "./Modal"
import {AuctionsState} from "../redux/reducers/AuctionReducer"
import Trans from './Trans'

type NavigationModalProps = {
  openModal: () => void
  hideModal: () => void
  modalOpen: boolean
  auctions: AuctionsState
}

class NavigationModal extends React.Component<NavigationModalProps> {
  constructor(props: NavigationModalProps) {
    super(props)
  };

  openModal = () => {
    this.props.openModal()
  }

  hideModal = () => {
    this.props.hideModal()
  }

  render() {
    const header = (
      <div className="px-3 py-2 text-gray-700 font-semibold flex flex-row justify-between items-center">
        <span className='truncate'><Trans>Navigation</Trans></span>

        <button onClick={this.hideModal} className={"flex border-0 font-semibold text-lg rounded text-gray-600 hover:text-gray-700 px-2 py-1 ml-2"} type="button">
          <Icon icon="times"/>
        </button>
      </div>
    )

    const body = (
      <div className="left-0 bottom-0 top-0 overflow-auto shadow sm:scrollbar sm:shadow-none min-w-xxs mt-2" id="sidebar">
        <div className="flex flex-col">
          {this.props.children}
        </div>
      </div>
    )

    return (
      <div className='w-full'>
        <div className='flex w-full'>
          <button onClick={this.openModal} className="rounded px-4 py-3 font-semibold whitespace-no-wrap bg-blue-800 hover:bg-blue-600 text-blue-100 flex">
            <Icon icon="bars"/>

            {location.pathname === '/' ?
              <span className="text-sm whitespace-no-wrap truncate flex items-center justify-center ml-2">{_.get(_.find(AppMenu(), {filter: this.props.auctions.filter.type || ''}), 'title', '')}</span>
              : location.pathname === '/dashboard' ?
                <span className="text-sm whitespace-no-wrap truncate flex items-center justify-center ml-2"><Trans>Dashboard</Trans></span>
                : null}
          </button>
        </div>
        {this.props.modalOpen ? <Modal body={body} header={header} pin={true}/> : null}
      </div>
    )
  }
}

export default NavigationModal
